import axios from './BaseService';

const API_URL =
    process.env.REACT_APP_API_URL || window._env_?.REACT_APP_API_URL;
const AUTOMATIONS_URL = `${API_URL}/automations/`;
const BACKTESTS_URL = `${API_URL}/backtests/`;

export async function doBacktest(newBacktest) {
    delete newBacktest.results;

    newBacktest.startTime = new Date(newBacktest.startTime).getTime();
    newBacktest.endTime = new Date(newBacktest.endTime).getTime();

    const response = await axios.post(
        `${AUTOMATIONS_URL}backtest`,
        newBacktest,
    );
    return response.data;
}

export async function getBacktests(page) {
    const response = await axios.get(`${BACKTESTS_URL}?page=${page}`);
    return response.data; //{count, rows}
}

export async function getBacktest(id) {
    const response = await axios.get(`${BACKTESTS_URL}${id}`);
    return response.data;
}

export async function deleteBacktest(id) {
    const response = await axios.delete(`${BACKTESTS_URL}${id}`);
    return response.data;
}
